import { useEffect } from 'react';
import { 
    Stack, 
    Paper, 
    Box, 
} from '@mui/material';
import BreadCrumbs from '../../../../components/BreadCrumbs';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import { getProductBySlug, } from '../reducers/productsReducers';
import { useLocation } from 'react-router-dom';
import SkeletonDetailProducts from '../detail/components/SkeletonProduct';
import DetailUpdateProduct from './components/DetailUpdateProduct';
import { useMediaQuery } from '@mui/material'

const UpdateProductPage = () => {
    const mobileDisplay = useMediaQuery('(min-width: 480px)')
    const dispatch = useDispatch()
    const location : any = useLocation()
    
    const store_product = useSelector((state : RootState) => state.products)

    // console.log(store_product, 'store_product')
    
    useEffect(() => {
        dispatch(getProductBySlug(location.state.slug))
        // eslint-disable-next-line
    }, [location]);

    return (
        <Box sx={ mobileDisplay?{pt:2, pl:3, pr:3} :  undefined}>
            <BreadCrumbs
                isPage={true}
                link="/dashboard/products"
                page="Product"
                current="Edit Product"
            />
            <Stack direction="row" justifyContent="space-between" pt={3} >
                <Box>
                    <h3>Edit Product</h3>
                </Box>
            </Stack>

            { store_product.loading_product_detail ? 
            <SkeletonDetailProducts/>
            : 
            <Stack>
                { store_product.product_detail_exist ?
                <Stack>
                    <DetailUpdateProduct dataproduct={store_product.product_detail}/>
                </Stack>
                :
                <Stack mt={2}>
                    <Paper elevation={2}>
                    <Stack direction="row" justifyContent="space-between" p={3} >
                        <Box>
                            <h4>Sorry, Product is not found. Please make sure the product slug is correct.</h4>
                        </Box>
                    </Stack>
                    </Paper>
                </Stack>
                }
            </Stack>
            }
        </Box>
    )
}

export default UpdateProductPage;
